var map = {
	"./circle-thumbnail.jpg": 4161,
	"./kubasi-sapiens-thumbnail.webp": 601,
	"./louise-parker-live-thumbnail.webp": 3643,
	"./mai-promo-thumbnail.webp": 7521,
	"./msubs-promo-thumbnail.webp": 3895,
	"./short-film-thumbnail.webp": 3406,
	"./soil-documentary-thumbnail.webp": 1235,
	"./the-hundred-hands-2021-portfolio-thumbnail.webp": 6210,
	"./the-kites-many-moons-thumbnail.webp": 6430,
	"./tom-ellie-wedding-thumbnail.webp": 7347
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8690;